import { Chip, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Flow } from '@thive/fddm-types';

import { theme } from '@/modules/common/theme';
import { getFlowStopDetails, getPaletteByLoadHandling } from '../helpers';

const OPACITY = 0.3;

type Props = {
  flow: Flow;
};

export function FlowDirection({ flow }: Props) {
  const source = getFlowStopDetails(flow.sourceAreaOrFlowStopId);
  const destination = getFlowStopDetails(flow.destinationAreaOrFlowStopId);

  const sourceColor = getPaletteByLoadHandling(source.loadHandlingType);
  const destinationColor = getPaletteByLoadHandling(destination.loadHandlingType);

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap={1}
      color='neutral.main'
      width='100%'
      marginTop={1}
      flexWrap='wrap'
    >
      <Chip
        label={source.name}
        sx={{
          backgroundColor: alpha(sourceColor, OPACITY),
          color: theme.palette.getContrastText(sourceColor),
          fontWeight: 500,
        }}
      />
      &nbsp;&mdash;&nbsp;
      <Chip
        label={destination.name}
        sx={{
          backgroundColor: alpha(destinationColor, OPACITY),
          color: theme.palette.getContrastText(destinationColor),
          fontWeight: 500,
        }}
      />
    </Stack>
  );
}
